function updateEmptyCartButton() {
	const currentCollectionUrl = sessionStorage.getItem('lastCollectionUrl')? sessionStorage.getItem('lastCollectionUrl') : "/collections/shop-all";
	const cartDrawerEmptyButton = document.querySelector("#CartDrawer .cart-drawer__empty-content .btn-continue-shopping");

	if (cartDrawerEmptyButton) cartDrawerEmptyButton.href = currentCollectionUrl;
}

function updateUrlHistory(newUrl) {
	sessionStorage.setItem('lastCollectionUrl', newUrl);
}

function favGetCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
  }

document.addEventListener('DOMContentLoaded', function() {
	
	if(favGetCookie('localization')!='US'){
		document.querySelector('.footer__menu_links li a[href*="attn.tv"]').parentElement.classList.add('hidden');
	}
});

document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.mega-menu > .header__menu-item');

    menuItems.forEach(item => {
        const megaMenu = item.closest('.mega-menu');
        const menuContent = megaMenu.querySelector('.mega-menu__content');

        if (!menuContent) return;

        item.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();

                megaMenu.setAttribute('open', '');
                item.setAttribute('aria-expanded', 'true');

                menuContent.removeAttribute('tabindex');

                const firstLink = menuContent.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
                if (firstLink) {
                    setTimeout(() => firstLink.focus(), 50);
                }
            }
        });

        menuContent.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();

                megaMenu.removeAttribute('open');
                item.setAttribute('aria-expanded', 'false');
                menuContent.setAttribute('tabindex', '-1');

                item.focus();
            }
        });
    });
});
